import { render, staticRenderFns } from "./RadioDefault.vue?vue&type=template&id=f29befe0&"
import script from "./RadioDefault.vue?vue&type=script&lang=js&"
export * from "./RadioDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports